

const Validations = () => {
    

}

function formatPhone(phoneNumber){
    if(phoneNumber.length === 11){
      return phoneNumber.replace(/(\d{2})(\d{5})(\d{4})/g, "\($1) $2-$3")
    }else{
      return phoneNumber.replace(/(\d{2})(\d{4})(\d{4})/g, "\($1) $2-$3")
    }
  }

export { Validations, formatPhone };